<template>
  <div class="kt-quick-panel--right" v-if="show">
    <div class="kt-quick-panel kt-quick-panel--on" :style="{ width: width + 'px !important', marginTop: '2.5rem' }">
      <a href="#" class="kt-quick-panel__close" @click="onClose">
        <font-awesome-icon :icon="['fas', 'times']" size="lg" />
      </a>
      <div class="kt-quick-panel__content pt-3">
        <slot />
      </div>
    </div>
    <div class="kt-quick-panel-overlay" @click="onClose"></div>
  </div>
</template>

<script>
export default {
  name: 'Sidebar',
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false
    },
    width: {
      type: Number,
      default: 300
    }
  },
  updated () {
    // document.body.classList.toggle('modal-open-two', this.show)
  },
  methods: {
    onClose () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scope>
.kt-quick-panel .kt-quick-panel__close {
  top: 2rem;
}
</style>
